<div class="container-fluid px-2 px-md-4 border-bottom py-3">
  @if(!hasUser){
  <div class="row justify-content-center align-items-center">
    <div class="col-auto">
      <figure>
        <img src="../../../assets/img/nav/la-colonial-de-seguros-logo.svg" width="214px" height="34px" alt="">
      </figure>
    </div>
  </div>
    }
  @if(hasUser){
  <div class="row justify-content-between align-items-center">
    <div class="col">
        <div class="d-flex align-items-center gap-2">
          <button (click)="openMobileNav.emit()" class="btn px-0 btn-sm d-flex d-md-none btn-outline-light text-colonial rounded-pill p-0">
            <span class="material-symbols-outlined" style="font-size: 1.8rem;">menu</span>
          </button>
          <div class="h6 mb-0 text-colonial lh-1 text-md-start d-flex flex-column align-content-center lh-0 g-0 gap-0">
            <span class="fw-semibold fs-5" style="height: 1.2rem; line-height: 1.2rem;">
              Tu Colonial 
            </span>
            <div class="text-muted small lh-1 d-block d-md-none">
                <small>{{user && user.idTokenClaims?.given_name}}</small>
            </div>
          </div>
        </div>
    </div>
    <div class="col d-none d-md-block">
      <div class="text-center rounded-3 gap-1 align-content-center px-2 py-1 border gap-0 align-items-center d-flex small justify-content-center bg-light">
        <span class="material-symbols-outlined" style="font-size: 20px;">account_circle</span>
        <span class="fw-normal lh-0 text-center">
          {{user && user.idTokenClaims?.given_name }}
        </span>
      </div>
    </div>
    <div class="col-auto col-md">
      <div class="d-flex gap-2 float-end">
        <a href="https://lacolonial.com.do/" target="_blank" class="btn ps-md-2 p-1 btn-outline-light border rounded-pill d-flex align-items-center btn-sm gap-2">
          <span class="fw-semibold text-secondary d-none d-md-block">Sitio web</span>
          <span class="material-symbols-outlined text-colonial" style="font-size: 1.5rem;">captive_portal</span>
        </a>
      </div>
    </div>
  </div>
}
</div>